<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202501_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202501_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-right"><span>みんなどうしてる？</span><br>自分に合った美容液の選び方</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">美容液選びの最適解<br>ポイントは美容成分と自分の肌悩みを知ること</h2>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3"><small>まずは知りたい！</small><br>美容液の役割と効果</h3>
        <p class="mb-3">みなさんは美容液と代表的な基礎化粧品である化粧水や乳液との、違いを意識したことがありますか？</p>
        <p class="mb-3">『美容液』は特定のお肌の悩みにたいして働きかけて、集中的なケアをする役割がメインの基礎化粧品です。</p>
        <p class="mb-3">そのため「ハリや弾力」「美白」「毛穴」など、肌悩み別に多くのラインナップが存在します。</p>
        <p class="mb-3">理由は、保湿成分にくわえて肌悩みの目的別にポイントとなる有効成分が配合されているから。</p>
        <p>そのため、目的に合わせた美容液を選ぶことができれば、効率的に高い美容効果を期待できます。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202501_02.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202501_03.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3"><small>美容液のおすすめの選び方はこれ</small><br>「肌悩み」と「美容成分」</h3>
        <p class="mb-3">口コミも大切ですが、まずは<stron>『自分の肌と向き合い、どんな肌悩みをケアしたいか』</stron>をポイントに選んでみてください。</p>
        <p class="mb-3">自分の肌に必要な美容液がわかってくると、<strong>お気に入りの美容成分</strong>が見つかり、スキンケア選びも楽しくなっていきます。</p>
        <p class="mb-3">また、せっかく美容液を使うのなら使用するタイミングも知っておきましょう。</p>
        <p>基礎化粧品は、一般的に「水分の多いもの」から「油分の多いもの」の順番で使用すると効果的といわれています。テクスチャーの使用感で見分けてみてくださいね。</p>
      </div>
    </div>
    
    <h3 class="my-5 pt-5 text-center">マナビス化粧品の製品の中でも、根強いファンの多い美容液たち。<br><br>人気の理由はこだわりぬいた『美容成分』<br><br>常にお客様のお肌のことを考えて<br>日々、商品開発・研究をしています。<br><br>これを実現できるのは<br>国内では数少ない自社工場をもつ、マナビス化粧品ならでは。</h3>
    <p class="text-center mb-5 pb-5">マナビス化粧品の美容液から<br>美容成分と肌のお悩み別に<br>おすすめアイテムを提案します。</p>
    <div><img src="@/assets/img/column/202501_04.jpg"></div>
    <h2 class="my-5 pt-5">美しくしなやかな「弾力美肌」へ。</h2>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202501_ace.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60 text-center">
        <h3 class="mb-3"><small>AGING CARE</small><br>薬用エイジングケアエッセンス</h3>
        <p class="mb-3">有効成分「ナイアシンアミド」配合の医薬部外品シワ改善エッセンス。</p>
        <p class="mb-3">日々変化していく肌にうるおいとハリを与えます。</p>
        <p class="mb-3">有効成分「ナイアシンアミド」がコラーゲンの生成を促進することでシワ改善に効果を発揮します。</p>
        <p class="mb-3">とろみのあるリッチなエッセンスが、加齢とともに変化していく肌をサポートします。</p>
        <p>ラベンダーのやさしい香りがお肌を包みます。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <h2 class="my-5 pt-5">肌にすうっとなじみ、キメを整えるスペシャルな美容液</h2>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202501_liftserum.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60 text-center">
        <h3 class="mb-3"><small>SPECIAL</small><br>リフトセラム</h3>
        <p class="mb-3">4種の「ヒアルロン酸」を贅沢に配合。</p>
        <p class="mb-3">更に数種の美容成分も配合し、<br>なじんだ後にピンとした上質なハリを感じます。</p>
        <p class="mb-3">肌の上にすべらせると、すうっと伸びて消えるようになじみ、キメを整えてくれます。</p>
        <p>なじんだ後にピンとしたハリを感じるのは、数種の美容成分が、贅沢に、理想的な比率で配合されているからです。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <h2 class="my-5 pt-5">なめらかで透明感のある肌へ。</h2>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202501_whiteningessence.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60 text-center">
        <h3 class="mb-3"><small>SPECIAL</small><br>薬用ホワイトニングエッセンスEX</h3>
        <p class="mb-3">安定した状態で角層の奥まで届き、透明感美肌へ導く、ビタミンC誘導体（L-アスコルビン酸 2-グルコシド）。</p>
        <p class="mb-3">肌あれを防ぐグリチルリチン酸ジカリウム。なめらかな肌へ導く数種の保湿成分。</p>
        <p>叶えたいのは、しなやかで明るい肌未来です。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <h2 class="my-5 pt-5"><small>番外編！マナビス化粧品の名品</small><br>スキンウォッシュ・スキンマスクの後に使ってほしい。<br>美肌菌に特化した美容液</h2>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202501_firstserum.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60 text-center">
        <h3 class="mb-3"><small>FLORA</small><br>フローラ ファーストセラム</h3>
        <p class="mb-3">すこやかさのカギを握る美肌菌と皮膚常在菌のバランスに着目した、洗顔後すぐに使う美肌菌に特化した美容液。</p>
        <p class="mb-3">肌をととのえながら、肌みずからうるおいを保つ力をサポートする、</p>
        <p>マナビスオリジナル処方・スキンバランシングフォーミュラF（整肌）が最大の魅力。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>

    <div class="layer_01  mt-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p>すべてのお客様に</p>
        <p class="mb-3 fs-2">自分の肌を好きでいてほしいから。</p>
        <p class="mb-3">肌の調子がいいと自分に自信が持てたり、<br>化粧ノリがいいと1日が少しハッピーだったり、<br>肌がキレイだと言われるとスキンケアの努力が報われていると自分を褒めたくなる。</p>
        <p class="mb-3">少しづつでも基本のことをコツコツ毎日と積み重ねる。</p>
        <p>明日の私の肌を好きでいるために、頑張るお客様をマナビス化粧品が力になれると嬉しいです。</p>
      </div>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>